import React, { useState } from "react";

import { PageLayout } from "../components/PageLayout";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useAppContext } from "../context/AppContext";

const UserPage: React.FC = () => {
  const { user, setUser } = useAppContext();
  const [form, setForm] = useState(user);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setUser(form);
  };

  return (
    <PageLayout title="User Profile">
      <div className="container max-w-xl w-full space-y-4">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">ID</label>
            <Input name="id" value={form.id} readOnly className="mt-1" />
          </div>
          <div>
            <label className="block text-sm font-medium">Name</label>
            <Input
              name="name"
              value={form.name}
              onChange={handleChange}
              className="mt-1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Email</label>
            <Input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              className="mt-1"
            />
          </div>
          <Button type="submit">Save</Button>
        </form>
      </div>
    </PageLayout>
  );
};

export default UserPage;
